import { render, staticRenderFns } from "./releaseDetail.vue?vue&type=template&id=bc218032&scoped=true&"
import script from "./releaseDetail.vue?vue&type=script&lang=js&"
export * from "./releaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./releaseDetail.vue?vue&type=style&index=0&id=bc218032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc218032",
  null
  
)

export default component.exports